import React from "react";
import { TCasesSailHomesReportForm, TAdhocTaskForms, TCasesCaseCreateAdhocForm } from "../../../../../../domain/codecs/form/CasesForm";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { Background } from "../../../BuildingBlocks/Background";
import { Padding } from "../../../BuildingBlocks/Padding";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { CRMEmptyPlaceholder } from "../../../Simple/CRMEmptyPlaceholder/CRMEmptyPlaceholder";
import { CRMButtonTertiary } from "../../../CRMButtonTertiary/CRMButtonTertiary";
import { CRMSailHomesReportRow } from "../CRMSailHomesReportRow/CRMSailHomesReportRow";

type TCRMSailHomesReportProps = {
    form: TCasesSailHomesReportForm;
    onLoadMore: () => void;
    onExpand: (caseId: string) => void;
    onGoToCase: (caseId: string) => void;
    onChangeTask: (caseId: string, form: TAdhocTaskForms) => void;
    onArchiveTask: (caseId: string, form: TAdhocTaskForms) => void;
    onSubmitNewTask: (caseId: string, form: TCasesCaseCreateAdhocForm) => void;
};

export const CRMSailHomesReport = (props: TCRMSailHomesReportProps): JSX.Element => {
    const { form } = props;

    const isLoading = form.status === "submitting";
    const rows = form.children.report_rows;
    const hasMore = rows.length < form.children.available_count;

    const emptyMessage = form.edited.filters.needs_action_only
        ? (form.edited.filters.under_offer_only
            ? "All Sail Homes under-offer cases have been progressed as far as they can today"
            : "All Sail Homes cases have been progressed as far as they can today")
        : "No Sail Homes cases match";

    return (
        <Background padding={`0px ${CRMSpacing.X_LARGE}`}>
            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                {rows.length === 0 && !isLoading &&
                    <CRMEmptyPlaceholder iconName="house">
                        {emptyMessage}
                    </CRMEmptyPlaceholder>
                }

                <SpacingColumn spacing={CRMSpacing.SMALL}>
                    {rows.map((row) => (
                        <CRMSailHomesReportRow
                            key={row.case_id}
                            row={row}
                            expandedCaseForm={form.children.expanded_case_forms.find((f) => f.original.id === row.case_id)}
                            assignableUsers={form.children.assignable_users}
                            onExpand={props.onExpand}
                            onGoToCase={props.onGoToCase}
                            onChangeTask={(taskForm) => props.onChangeTask(row.case_id, taskForm)}
                            onArchiveTask={(taskForm) => props.onArchiveTask(row.case_id, taskForm)}
                            onSubmitNewTask={(taskForm) => props.onSubmitNewTask(row.case_id, taskForm)}
                        />
                    ))}
                </SpacingColumn>

                {hasMore &&
                    <Padding spacing={`${CRMSpacing.MEDIUM} 0px`}>
                        <SpacingRow justifyContent="center">
                            <CRMButtonTertiary
                                label={isLoading ? "Loading..." : "See more"}
                                onClick={props.onLoadMore}
                            />
                        </SpacingRow>
                    </Padding>
                }
            </SpacingColumn>
        </Background>
    );
};
